import React, { CSSProperties } from 'react';

interface Props {
  style?: CSSProperties;
}

const RoundedTickSVG: React.FC<Props> = ({ style = {} }) => (
  <svg style={style} id="Component_10_7" data-name="Component 10 – 7" xmlns="http://www.w3.org/2000/svg" width="29.017" height="29.016" viewBox="0 0 29.017 29.016">
    <path id="Path_794" data-name="Path 794" d="M182.508,890.02a14.508,14.508,0,1,0,14.508,14.508A14.524,14.524,0,0,0,182.508,890.02Z" transform="translate(-168 -890.02)" fill="#a177ff" />
    <path id="Path_795" data-name="Path 795" d="M177.3,906.6l-2.477-2.843-1.527,1.753,4,4.6,10.485-12.037-1.527-1.753Z" transform="translate(-166.029 -888.7)" fill="#fff" />
  </svg>
);

export default RoundedTickSVG;